import { Outlet } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from '@/contexts/auth';
import { Layout } from '@/components/Layout';
import { Protected } from '@/components/Protected';
import { ScoringProvider } from '@/contexts/scoring/provider';
import { PreferencesProvider } from '@/contexts/preferences/provider';
import { SnacksProvider } from '@/contexts/snacks/provider';
import { StatsProvider } from '@/contexts/stats/provider';
import { VisualNotificationsProvider } from '@/contexts/visualNotifications/provider';
import { StreamingProvider } from '@/contexts/streaming/provider';
import { RolePermissionsProvider } from '@/contexts/rolePermissions/provider';
import { MarketsProvider } from '@/contexts/markets/provider';
import { UserProvider } from '@/contexts/user/provider';
import { ComposeComponents } from './utils/ComposeComponents';
import { UiStateProvider } from './contexts/UIState/provider';
import { ChecklistProvider } from './contexts/checklist/provider';
import { NotificationsProvider } from './contexts/notifications/provider';
import { AudioRecordsProvider } from './contexts/audioRecords/provider';

export function App() {
  return (
    <ComposeComponents
      components={[
        AuthProvider,
        RolePermissionsProvider,
        CssBaseline,
        PreferencesProvider,
        NotificationsProvider,
        ScoringProvider,
        SnacksProvider,
        Protected,
        UserProvider,
        VisualNotificationsProvider,
        MarketsProvider,
        UiStateProvider,
        ChecklistProvider,
        StatsProvider,
        StreamingProvider,
        AudioRecordsProvider,
      ]}
    >
      <Layout>
        <Outlet />
      </Layout>
    </ComposeComponents>
  );
}
